<template>
  <div id="app" class="container">
    <header class="justify-content-center py-1 mb-4 border-bottom">
      <span class="fs-4">簽到系統</span>
      <h1 v-if="courseName">課程:{{ courseName }}</h1>
      <span v-if="memberCount">完成簽到人數:{{ memberCount }}</span>
    </header>
    <b-alert :show="dismissCountDown" variant="success" @dismissed="onDismissed" @dismiss-count-down="countDownChanged">
      <p>簽到成功 {{ dismissCountDown }} 秒後前往課程頁面...</p>
      <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
    </b-alert>
    <b-alert show variant="info" v-if="isShowInfo">
      <pre>{{ description }}</pre>
      <!--
      上課時間：8/5(六)08:45-11:00<br>
      簽到時間：8/5(六)08:15-11:30  
      上課時間：8:45-11:00
      簽到時間：8:15-11:30

      補課時間：4/19(三)05:00-5/2(二)23:59
    <b-list-group>
        <b-list-group-item>非假日</b-list-group-item>
        <b-list-group-item>1.(11/10四早)09:00~12:00</b-list-group-item>
        <b-list-group-item>2.(11/10四午)14:00~17:00</b-list-group-item>
        <b-list-group-item>3.(11/10四晚)19:00~22:00</b-list-group-item>
        <b-list-group-item>4.(11/11五早)05:00~08:00早鳥場</b-list-group-item>
        <b-list-group-item>5.(11/11五午)14:00~17:00</b-list-group-item>
        <b-list-group-item>6.(11/11五晚)21:00~23:59午夜場</b-list-group-item>
        <b-list-group-item>7.(11/14一午)14:00~17:00</b-list-group-item>
        <b-list-group-item>8.(11/14一晚)19:00~22:00</b-list-group-item>
        <b-list-group-item>9.(11/15二早)09:00~12:00</b-list-group-item>
        <b-list-group-item>10.(11/15二晚)19:00~22:00</b-list-group-item>
        <b-list-group-item>假日場</b-list-group-item>
        <b-list-group-item>1.(11/12六早)09:00~12:00</b-list-group-item>
        <b-list-group-item>2.(11/12六午)14:00~17:00</b-list-group-item>
        <b-list-group-item>3.(11/12六晚1)18:20~21:20</b-list-group-item>
        <b-list-group-item>4.(11/12六晚2)21:40~00:40午夜場</b-list-group-item>
        <b-list-group-item>5.(11/13日早1)05:00~08:00早鳥場</b-list-group-item>
        <b-list-group-item>6.(11/13日早2)09:00~12:00</b-list-group-item>
        <b-list-group-item>7.(11/13日午)14:00~17:00</b-list-group-item>
        <b-list-group-item>8.(11/13日晚)19:00~22:00</b-list-group-item>
      </b-list-group>
     -->
    </b-alert>
    <b-form :validated="isValidated" v-if="!isSuccess && form.courseId > 0">
      <b-alert show v-if="isSignUpMode" variant="warning">查不到您的資料，請填寫完整簽到表</b-alert>
      <b-form-group label="姓名:" label-for="name" class="mb-3" invalid-feedback="請輸入姓名">
        <b-form-input id="name" v-model="form.name" placeholder="請輸入姓名" required></b-form-input>
      </b-form-group>
      <b-form-group label="手機號碼:" label-for="phone" description invalid-feedback="請輸入手機號碼">
        <vue-tel-input id="phone" @input="onPhoneInput" class="phoneNumber" name="phone" v-bind="bindProps"
          required></vue-tel-input>
      </b-form-group>
      <b-button v-if="!isSignUpMode" variant="primary" @click="onSignIn">簽到</b-button>
      <b-form-group v-if="isSignUpMode" label="區別:" label-for="area" class="mb-3">
        <b-form-radio-group id="area" v-model="form.area" :aria-describedby="ariaDescribedby" name="area" stacked
          required>
          <b-form-radio value="北區">北區</b-form-radio>
          <b-form-radio value="桃區">桃區</b-form-radio>
          <b-form-radio value="竹區">竹區</b-form-radio>
          <b-form-radio value="中區">中區</b-form-radio>
          <b-form-radio value="嘉區">嘉區</b-form-radio>
          <b-form-radio value="南區">南區</b-form-radio>
          <b-form-radio value="園區">園區</b-form-radio>
          <b-form-radio value="高區">高區</b-form-radio>
          <b-form-radio value="海外:世界各國">海外:世界各國</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group v-if="isSignUpMode" label="班級:" label-for="lamrimClass" class="mb-3">
        <b-form-input id="lamrimClass" v-model="form.lamrimClass" placeholder="請輸入班級" required></b-form-input>
      </b-form-group>
      <b-form-group v-if="isSignUpMode" label="身分:" label-for="role" class="mb-3" invalid-feedback="請勾選身分">
        <b-form-checkbox-group v-model="form.roles" :options="roles" :state="state" name="role"
          required></b-form-checkbox-group>
        <!--
            <b-form-checkbox v-model="form.isRole1" :value="true" :unchecked-value="false">現任班長</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole2" :value="true" :unchecked-value="false">現任副班長</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole3" :value="true" :unchecked-value="false">現任關懷員</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole4" :value="true" :unchecked-value="false">推薦關懷員</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole5" :value="true" :unchecked-value="false">傳燈服務義工</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole6" :value="true" :unchecked-value="false">淨智全兼職</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole7" :value="true" :unchecked-value="false">特推人員</b-form-checkbox>
            <b-form-checkbox v-model="form.isRole8" :value="true" :unchecked-value="false">海外人員</b-form-checkbox>
            -->
      </b-form-group>
      <b-button v-if="isSignUpMode" variant="primary" @click="onSignUp">簽到</b-button>
    </b-form>
    <!-- <div v-if="isSuccess" style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/944672825?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="補課版_20240504全區班長班"></iframe></div> -->
  </div>
</template>

<script>
const baseUrl = "https://gf-signin-api.luciditv.app";
const siteId = 1;
//const baseUrl = "http://127.0.0.1:3000";
export default {
  name: "App",
  components: {},
  data() {
    return {
      roles: [
        { text: '班長', value: 'isRole1' },
        { text: '副班長', value: 'isRole2' },
        { text: '關懷員', value: 'isRole3' },
        { text: '卸任', value: 'isRole10' },
        //{ text: '推薦關懷員', value: 'isRole4'},
        { text: '傳燈服務義工', value: 'isRole5' },
        { text: '淨智全兼職', value: 'isRole6' },
        //{ text: '特推人員', value: 'isRole7'},
        //{ text: '海外人員', value: 'isRole8'},
        { text: '其他', value: 'isOthers' },
      ],
      description:"",
      isShowInfo: false,
      isSuccess: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      url: null,
      message: null,
      courseName: null,
      isValidated: null,
      form: {
        courseId: null,
        name: null,
        country: null,
        phoneNumber: null,
        phoneCountryCode: null,
        lamrimClass: null,
        area: null,
        roles: [],
        isRole1: false,
        isRole2: false,
        isRole3: false,
        isRole4: false,
        isRole5: false,
        isRole6: false,
        isRole7: false,
        isRole8: false,
        isRole9: false,
        isRole10: false,
        isOthers: false,
      },
      phoneValid: false,
      show: true,
      bindProps: {
        preferredCountries: [
          "TW",
          "CA",
          "US",
          "JP",
          "KR",
          "SG",
          "MY",
          "IN",
          "VN",
        ],
        inputOptions: {
          placeholder: "請輸入報名時的手機號碼",
          required: true,
        },
      },
      isSignUpMode: false,
    };
  },

  async created() {
    try {
      const response = await fetch(`${baseUrl}/api/courses?siteId=${siteId}`, {
        mode: 'cors',
        method: "GET",
        headers: { "content-type": "application/json" }
      });
      const courses = await response.json();
      const currentCourse = courses.find(course => {
        const startTime = new Date(course.startTime);
        const endTime = new Date(course.endTime);
        return startTime < Date.now() && endTime > Date.now();
      });
      if (currentCourse) {
        this.courseName = currentCourse.name;
        this.memberCount = currentCourse.memberCount;
        this.form.courseId = currentCourse.id;
      } else {
        const response = await fetch(`${baseUrl}/api/nextcourse?siteId=${siteId}`, {
          mode: 'cors',
          method: "GET",
          headers: { "content-type": "application/json" }
        });
        const course = await response.json();
        if(course) {
          this.description = course.description
        }
        this.isShowInfo = true;
      }
    } catch (error) {
      // handle error
    }
    this.timer();
  },
  methods: {
    timer() {
      let self = this
      setInterval(() => {
        if (self.form.courseId == null) {
          fetch(`${baseUrl}/api/courses?siteId=${siteId}`, {
            mode: 'cors',
            method: "GET",
            headers: { "content-type": "application/json" }
          }).then(async res => {
            const json = await res.json();
            const now = new Date();
            const course = json.find(c => {
              return new Date(c.startTime) < now && new Date(c.endTime) > now
            })
            if (course) {
              self.courseName = course.name
              self.memberCount = course.memberCount
              self.form.courseId = course.id
              self.isShowInfo = false
            } else {
              self.isShowInfo = true
            }
          })
        }
      }, 30000)
    },
    onDismissed() {
      this.dismissCountDown = 0
      if (this.url) {
        window.location.href = this.url;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    onPhoneInput(formattedNumber, { number, valid, country }) {
      this.form.phoneNumber = number;
      this.form.phoneCountryCode = country.dialCode;
      this.form.country = country.iso2;
      this.phoneValid = valid;
    },
    async onSignUp() {
      if (!this.form.name || !this.form.area || !this.phoneValid || !this.form.lamrimClass || this.form.roles.length == 0) {
        this.isValidated = true;
        return;
      }
      for (const role of this.form.roles) {
        this.form[role] = true;
      }
      const res = await fetch(`${baseUrl}/api/signup?siteId=${siteId}`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form),
      });
      const json = await res.json();
      if (json.code == 200) {
        this.isSuccess = true;
        this.showAlert();
        this.url = json.url;
      } else if (json.code == 404) {
        this.isSignUpMode = true;
      }
    },
    async onSignIn() {
      if (!this.form.name || !this.phoneValid) {
        this.isValidated = true;
        return;
      }
      const res = await fetch(`${baseUrl}/api/signin?siteId=${siteId}`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form),
      });
      const json = await res.json();
      if (json.code == 200) {
        this.isSuccess = true;
        this.showAlert();
        this.url = json.url;
        window.location.href = json.url;
      } else if (json.code == 404) {
        this.isSignUpMode = true;
      }
    },
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
